// Centralized audio keys to avoid stringly-typed usage across scenes.
export const BGM = {
  Menu: 'bgm_menu_theme',
  Level1: 'bgm_level_theme_1',
} as const;

export type BgmKey = typeof BGM[keyof typeof BGM];

export const SFX = {
  Shoot: 'sfx_shoot',
  EnemyHit: 'sfx_enemy_hit',
  EnemyDeath: 'sfx_enemy_death',
  PlayerHit: 'sfx_player_hit',
  PlayerDeath: 'sfx_player_death',
  Pickup: 'sfx_pickup',
  UiClick: 'sfx_ui_click',
  GameOver: 'sfx_game_over',
  LevelComplete: 'sfx_level_complete',
} as const;

export type SfxKey = typeof SFX[keyof typeof SFX];